import React from 'react'
import { FaLinkedin } from "react-icons/fa6";
import { FaHeart } from "react-icons/fa";

function Footer() {
  return (
<div className='w-full bg-richblack-900 '>
        <div className='flex lg:justify-between flex-wrap gap-2 w-11/12 mx-auto font-mulish text-white  '>
          <div>
          <a 
          className='flex items-center gap-2 underline '
          href="https://mahi-technocrafts.vercel.app/"> 
            Powered By Mahi TechnoCrafts
          </a>
          </div>


          <div>
          <a 
          className='flex items-center gap-2 underline'
          href="https://portfolio-vikash-gilt.vercel.app/" target='_blank'> 
          Made With <FaHeart className='text-red' />          Vikash Maheshwari
          </a>
          </div>
          
        </div>

</div>
  )
}

export default Footer